import List from '../../components/lists/List'
import MenuItem from './MenuItem'

export default class MenuList extends List {
  _init() {
    this._selectedIndex = 0
    this.orientation = 'vertical'
  }

  set menuItems(items) {
    this.items = items.map(item => {
      return { type: MenuItem, h: 90, item }
    })
  }

  set spacing(spacing) {
    this._spacing = spacing
  }

  get spacing() {
    return this._spacing
  }

  get listWidth() {
    return this.tag('Wrapper').w
  }

  set selected(idx) {
    this._selectedIndex = idx
  }

  get selected() {
    return this._selectedIndex
  }

  get currentItem() {
    return this.tag('Wrapper').children[this._index]
  }

  get currentMenuItem() {
    return this.currentItem.item
  }

  _resizeWrapper(obj) {
    this.wrapper.patch(obj)

    if (this._autoResize) {
      this.patch(obj)
    }
  }

  _indexChanged(obj) {
    super._indexChanged(obj)
  }

  _navigate(shift, orientation = this._orientation) {
    if (shift === 1 && this.index === this.items.length - 1) {
      return false
    }

    const targetIndex = this._index + shift

    if (this._orientation === orientation && targetIndex >= 0 && targetIndex < this.items.length) {
      const previousIndex = this._index
      this._index = targetIndex
      this._indexChanged({ previousIndex, newIndex: targetIndex, dataLength: this.items.length })
      return true
    }

    return false
  }
}
